import { createRouter, createWebHistory } from "vue-router";
import { getRoutes } from "./routes";
import { checkAuthorization } from "./authorization";
import store from "../store.js";
import Clarity from "@microsoft/clarity";
import { CLARITY_ENABLED } from "@/config/index.js";
import i18n from "@/lib/i18n";

const router = createRouter({
  linkActiveClass: "open active",
  scrollBehavior: (to, from, savedPosition) => {
    if (to.name !== undefined) {
      if (to?.name === "calendar.presences.child" || to?.name?.includes("transactions.parent")) {
        return savedPosition;
      } else if (to?.name === "calendar.subjects" && from?.name === "calendar.presences.child") {
        return savedPosition;
      } else if (
        to?.name?.includes("transactions") &&
        from?.name?.includes("transactions.parent")
      ) {
        return savedPosition;
      }
    }

    return { top: 0 };
  },
  history: createWebHistory(),
  routes: getRoutes(),
});

checkAuthorization(router);

router.afterEach((to) => {
  if (CLARITY_ENABLED && typeof to.meta.clarityUpgradeReason === "string") {
    Clarity.upgrade(to.meta.clarityUpgradeReason);
  }
});

router.beforeEach((to, from, next) => {
  const hasUnsavedChanges = store.getters["hasUnsavedChanges"];

  if (!hasUnsavedChanges) {
    next();

    return;
  }

  if (
    confirm(
      i18n.global.t(
        "You have some unsaved changes. Are you sure you want to leave this page without saving changes?",
      ),
    )
  ) {
    store.dispatch("setHasUnsavedChanges", false);

    next();
  } else {
    next(false);
  }
});

export default router;
